import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import PLForm from "../components/PLForm";

export default function PageCreatePL() {
  return (
    <>
      <HeaderBarInternal title="Nova proposição legislativa" backTo="/pls" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados da proposição legislativa
          <span>Identifique uma nova proposição legislativa Patri</span>
        </Heading>

        <CardForm>
          <PLForm />
        </CardForm>
      </Container>
    </>
  );
}
